import { GetterTree, Getter } from 'vuex';
import { RootState, Individu } from '@/store/types';
import { IndividuState } from './type';
import { utils } from '@/util';

export const getListIndividus : Getter<IndividuState, RootState> = state => state.listIndividus;
export const getFiltredListIndividus : Getter<IndividuState, RootState> = state => state.filtredListe;
export const getIndividu : Getter<IndividuState, RootState> = state => state.individu;
export const getListEcoles : Getter<IndividuState, RootState> = state => state.listEcoles;
export const getListClasses : Getter<IndividuState, RootState> = state => state.listClasses;
export const getListInstits : Getter<IndividuState, RootState> = state => state.listInstits;
export const getListHisto : Getter<IndividuState, RootState> = state => state.listHisto;
export const getListNiveau : Getter<IndividuState, RootState> = state => state.listNiveau;
export const getListAutorisations : Getter<IndividuState, RootState> = state => state.listAutorisations;
export const getListVille : Getter<IndividuState, RootState> = state => state.listVille;
export const getCurrentAnneeScolaire : Getter<IndividuState, RootState> = state => state.currentAnneeScolaire;
export const getListEtablissementScolaireNiveau : Getter<IndividuState, RootState> = state => state.listEtablissementScolaireNiveau;
export const getListClasseScolaireNiveau : Getter<IndividuState, RootState> = state => state.listClasseScolaireNiveau;
export const getListClasseScolaireEnseignant : Getter<IndividuState, RootState> = state => state.listClasseScolaireEnseignant;
export const getIsIndividusDuJours : Getter<IndividuState, RootState> = state => state.filtreIndividusJour;



export const getters: GetterTree<IndividuState, RootState>={
    getListIndividus,
    getFiltredListIndividus,
    getIndividu,
    getListEcoles,
    getListClasses,
    getListInstits,
    getListHisto,
    getListNiveau,
    getListAutorisations,
    getListVille,
    getCurrentAnneeScolaire,
    getListEtablissementScolaireNiveau,
    getListClasseScolaireNiveau,
    getListClasseScolaireEnseignant,
    getIsIndividusDuJours
   
}